<template>
  <div class="w-full h-full overflow-hidden">
    <column-header v-if="data.showTitle" :title="title" :showMore="false" class="mb-5px" />
    <div
      class="w-full h-[calc(100%-43px)] relative"
      :class="data.showTitle ? 'h-[calc(100%-43px)]' : 'h-full'"
    >
      <iframe ref="iframe" :src="iframeUrl" frameborder="0" class="w-full h-full"></iframe>
    </div>
  </div>
</template>

<script>
import { ColumnTableApi } from '@wiz-api/workbench-std'
import addRequestQueue from '@/assets/js/RequestQueue'
import ColumnHeader from './ColumnHeader'

const columnTableApi = new ColumnTableApi()
export default {
  components: {
    ColumnHeader,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (!_.isEmpty(val)) {
          if (val.title) this.title = val.title
          if (val.dataSource && val.dataSource !== oldVal?.dataSource) {
            this.getCompentsData(val.dataSource)
          }
        }
      },
    },
  },
  data() {
    return {
      title: '',
      iframeUrl: '',
    }
  },
  methods: {
    async getCompentsData(id) {
      const param = {
        columnId: id,
        isShow: true,
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getLinkColumnTable(1, 99, param)
      })
      if (!err && res && res?.items?.length > 0) {
        this.title = this.data.title || res.items[0].title
        this.iframeUrl = res.items[0].url
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
